import {axiosRequest} from "../api";
import {API_PATH} from "../../constants";

export const AppointmentService = {
    getAppointmentsList(params){ return axiosRequest('GET', API_PATH.APPOINTMENT.LIST(params)) },
    getAppointment(data){ return axiosRequest('POST', API_PATH.APPOINTMENT.INFO, data) },
    addAppointment(data){ return axiosRequest('POST', API_PATH.APPOINTMENT.ADD, data) },
    changeStatusAppointment(data){ return axiosRequest('POST', API_PATH.APPOINTMENT.STATUS, data) },
}